import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import { getTheme } from './lib/theme.js';
import './styles.css';

// Aplica o tema salvo antes de renderizar (sem flash).
document.documentElement.dataset.theme = getTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
